<script>
	import { activeFeature } from "./stores.js";
</script>

<style type="text/scss">
	@import "./style/vars";
</style>

<h1>
	<!-- {$activeFeature ? $activeFeature.properties.NAME : 'USA'} -->
	{$activeFeature.properties.NAME}
</h1> 
